import { normalizeAppLanguage } from "util/locale";

// Format and data live in the Advisor's morning_brief flow; this only names the day and language.
const MORNING_BRIEF_PROMPT_TR = "Dün ({DAY}) için sabah brifi. Türkçe yaz.";
const MORNING_BRIEF_PROMPT_EN = "Morning Brief for yesterday ({DAY}). Write it in English.";
const TODAYS_BRIEF_PROMPT_TR = "Bugün ({DAY}) şu ana kadarki günün brifi. Türkçe yaz.";
const TODAYS_BRIEF_PROMPT_EN = "Today's Brief for today so far ({DAY}). Write it in English.";

function fillPrompt(tr, en, language, day) {
  const prompt = normalizeAppLanguage(language) === "tr" ? tr : en;
  return prompt.split("{DAY}").join(day);
}

export function getMorningBriefPrompt(language, day) {
  return fillPrompt(MORNING_BRIEF_PROMPT_TR, MORNING_BRIEF_PROMPT_EN, language, day);
}

export function getTodaysBriefPrompt(language, day) {
  return fillPrompt(TODAYS_BRIEF_PROMPT_TR, TODAYS_BRIEF_PROMPT_EN, language, day);
}
